// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"00fc57b5","408":"c3f5b9e9"}[chunkId] + ".chunk.js";
};